import {
  Alert,
  Card,
  Grid,
  Text,
} from '@mantine/core'
import { IconAlertTriangle } from '@tabler/icons-react'

import {
  Valve,
  WARNING_STATES,
} from '@data/device/model/device'

export interface ValveStatsGridProps {
  valves: Valve[]
}

// Shared by the Device Modal's Valves tab and the standalone Operate Valves page.
export const ValveStatsGrid = ({ valves }: ValveStatsGridProps) => {
  const installedCount = valves.filter((v) => v.state !== 7 && v.state != null).length
  const openCount = valves.filter((v) => v.state === 1).length
  const warningCount = valves.filter((v) => WARNING_STATES.includes(v.state)).length

  return (
    <>
      <Grid>
        <Grid.Col span={{ base: 12, md: 4 }}>
          <Card withBorder p='md'>
            <Text size='sm' c='dimmed'>
              Installed
            </Text>
            <Text fw={700} size='xl'>
              {installedCount}/5
            </Text>
          </Card>
        </Grid.Col>

        <Grid.Col span={{ base: 12, md: 4 }}>
          <Card withBorder p='md'>
            <Text size='sm' c='dimmed'>
              Open
            </Text>
            <Text fw={700} size='xl' c='green'>
              {openCount}
            </Text>
          </Card>
        </Grid.Col>

        <Grid.Col span={{ base: 12, md: 4 }}>
          <Card withBorder p='md'>
            <Text size='sm' c='dimmed'>
              Issues
            </Text>
            <Text
              fw={700}
              size='xl'
              c={warningCount > 0 ? 'orange' : 'green'}
            >
              {warningCount}
            </Text>
          </Card>
        </Grid.Col>
      </Grid>

      {warningCount > 0 && (
        <Alert
          color='orange'
          variant='light'
          icon={<IconAlertTriangle size={18} />}
        >
          One or more valves are in a warning or non-ideal state.
        </Alert>
      )}
    </>
  )
}
